import api from "./api-utils";

export const getTagGroupsForAsset = async (assetId) => {
  const response = await api.get(
    `/api/tags/tag-groups/${assetId}?includeGroups=true`
  );
  return response.data;
};

/**
 * Fetch tag groups for a specific asset's tenant
 * @param {string|number} assetId - Asset ID
 * @returns {Promise<Array>} Tag group list
 */
export const getTagGroupsForAssetTenant = async (assetId) => {
  const response = await api.get(`/api/taggroups/list-for-asset/${assetId}`);
  return response.data;
};

/**
 * Fetch tag groups for the current session tenant.
 * @returns {Promise<Array>} Tag group list
 */
export const getTagGroupsForTenant = async () => {
  const response = await api.get("/api/taggroups/list");
  return response.data;
};

/**
 * Fetch universal descriptor tag counts by tenant
 * @returns {Promise<Array>} Tenant descriptor count list
 */
export const getUniversalDescriptorTagCounts = async () => {
  const response = await api.get("/api/universalDescriptors/tag-counts");
  return response.data;
};

/**
 * Create a new tag group
 * @param {string} name - Group name
 * @param {string} description - Group description
 * @param {number[]} universalDescriptorIds - UniversalDescriptorIds assigned to group
 * @returns {Promise<Object>} Created group response
 */
export const createTagGroup = async (
  name,
  description,
  universalDescriptorIds
) => {
  const response = await api.post("/api/taggroups/add", {
    TagGroupName: name,
    TagDescription: description,
    UniversalDescriptorIds: universalDescriptorIds,
  });
  return response.data;
};

/**
 * Update an existing tag group
 * @param {number} groupId - Group ID
 * @param {string} name - Group name
 * @param {string} description - Group description
 * @param {number[]} universalDescriptorIds - UniversalDescriptorIds assigned to group
 * @returns {Promise<Object>} Updated group response
 */
export const updateTagGroup = async (
  groupId,
  name,
  description,
  universalDescriptorIds
) => {
  const response = await api.put("/api/taggroups/update", {
    TagGroupId: groupId,
    TagGroupName: name,
    TagGroupDescription: description,
    UniversalDescriptorIds: universalDescriptorIds,
  });
  return response.data;
};

/**
 * Delete an existing tag group
 * @param {number} groupId - Group ID
 * @returns {Promise<void>} Delete result
 */
export const deleteTagGroup = async (groupId) => {
  await api.delete(`/api/taggroups/delete/${groupId}`);
};
